module.exports = __webpack_public_path__ + "img/Sibiu_9_kl.c471d5ed.jpg";